import React from 'react';
import { RatingSummary } from '../hooks/useProductRating';
import Button from '../root/components/buttons/Button';
import styles from './ProductRating.module.scss';
import Stars from './Stars';

export const ProductRating: React.FC<{ rating: RatingSummary; onClick: () => void }> = ({ rating, onClick }) => {
  return (
    <div className={styles.ratingContainer}>
      <Stars amount={rating.rating} />
      <Button
        dataTrackLabel="Read Reviews"
        dataTrackLocation="PDP"
        buttonType="link"
        labelStyleOptions={{ underline: true, color: '#6065e0' }}
        onClick={onClick}
        size="small"
        text={`(${rating.totalReviews || '-'}) Read reviews`}
      />
    </div>
  );
};

export default ProductRating;
